<form name="{{ 'form_' + facet.key }}" class="sh-facet" *ngIf="facet$ | async as facet">
    <label *ngIf="showLabel" class="sh-facet__label">{{ facet.label }}</label>
    <ul class="sh-facet__values sh-form-check-list">
        <li *ngFor="let facetValue of facet.values; trackBy: trackByLabel" class="sh-facet__values__value sh-form-check sh-form-check-list__item">
            <div class="sh-form-check sh-form-check-list__item__check">
                <input
                    type="checkbox"
                    id="{{
                        facetDialogOpen ? 'dialog_facet_' + facet.key + '_value_' + facetValue.label : 'facet_' + facet.key + '_value_' + facetValue.label
                    }}"
                    class="sh-form-check__input"
                    [ngClass]="facet.selectionType === ShFacetSelectionType.MUST ? 'sh-radio' : 'sh-checkbox'"
                    name="{{ 'facet_' + facet.key }}"
                    [value]="facetValue.value"
                    [checked]="facetValue.selected"
                    (change)="onSelectionChange(facet, facetValue)"
                />
                <label
                    class="sh-form-check__label"
                    for="{{
                        facetDialogOpen ? 'dialog_facet_' + facet.key + '_value_' + facetValue.label : 'facet_' + facet.key + '_value_' + facetValue.label
                    }}"
                    [title]="facetValue | FacetValueLabel: facet.label : (noValueKey | translate) : noValueKey"
                >
                    <div class="sh-facet__values__value__text">{{ facetValue | FacetValueLabel: facet.label : (noValueKey | translate) : noValueKey }}</div>
                    <div *ngIf="facetValue.count > 0" class="sh-facet__values__value__count">({{ facetValue.count }})</div>
                </label>
            </div>
        </li>
    </ul>
    <a *ngIf="showLoadMore" tabindex="0" (click)="onShowMore(facet)" class="sh-facet__more_link" (keyup.Space)="onShowMore(facet)" (keyup.Enter)="onShowMore(facet)">{{ showMoreMsg }}</a>
</form>
